import * as store from '@attain-apps/fe/web/main/lib/store'
import * as rxjs from 'rxjs'

import type { Api } from '../../api'
import type { Feature } from '../feature'

/** Requests a temporary URL for the selected document. */
export const executeDownload = store.effects.create(
  (feature: Feature, api: Api) =>
    feature.actions.download.request.observe().pipe(
      rxjs.mergeMap(action =>
        api
          .createDownloadUrl({
            dataSourceId: action.data.dataSourceId,
            key: action.data.key,
            knowledgeBaseId: action.data.knowledgeBaseId,
          })
          .pipe(
            rxjs.map(response =>
              feature.actions.download.success.from(action).create({
                request: action.data,
                response,
              }),
            ),
            rxjs.catchError((error: Error) =>
              rxjs.of(
                feature.actions.download.error.from(action).create({
                  error,
                  request: action.data,
                }),
              ),
            ),
          ),
      ),
    ),
)
